import { render } from "./DemandOrderResult.vue?vue&type=template&id=085ee24c"
import script from "./DemandOrderResult.vue?vue&type=script&lang=js"
export * from "./DemandOrderResult.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./DemandOrderResult.vue?vue&type=style&index=0&id=085ee24c&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/driver/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__